"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
class SlickArrow extends react_1.default.PureComponent {
    render() {
        const classProps = {
            style: this.props.style,
            className: this.props.className,
            onClick: this.props.onClick,
            key: this.props.key,
            'data-role': this.props['data-role']
        };
        return (react_1.default.createElement("div", Object.assign({}, classProps),
            react_1.default.createElement("div", { role: "button", className: "slick-control" },
                react_1.default.createElement("i", { className: "icon-arrow" }))));
    }
}
exports.default = SlickArrow;
SlickArrow.propTypes = {
    className: prop_types_1.default.string,
    style: prop_types_1.default.object,
    onClick: prop_types_1.default.func,
    key: prop_types_1.default.string,
    'data-role': prop_types_1.default.string
};
//# sourceMappingURL=SlickArrow.js.map